import request from 'Request'
import EventService from 'Services/events'

const EncountersService = {
  async get({ hl7Id, encounterId }) {
    return request.get('/encounters/get', { params: { hl7Id, encounterId } })
  },

  async list({
    virtualOfficeId,
    searchingParams,
    sortingParams,
    filteringParams,
    searchParams,
    skip,
    limit
  }) {
    return request.post('/encounters/list', {
      virtualOfficeId,
      searchingParams,
      sortingParams,
      filteringParams,
      searchParams,
      skip,
      limit
    })
  },

  async updateReviewInfo({ encounterId, hl7Id, userId, status }) {
    return request.patch('/encounters/update-review-info', { encounterId, hl7Id, userId, status })
  },

  async claim({ encounterId }) {
    return request.patch('/encounters/claim', { encounterId })
  },

  async updateStatus({ encounterId, oldStatus, newStatus }) {
    const updateEncounter = await this.updateReviewInfo({
      status: newStatus,
      encounterId
    })

    if (!updateEncounter) return updateEncounter

    return EventService.create({
      type: 'encounterEvent',
      event: 'update',
      encounterId,
      data: {
        oldStatus,
        newStatus
      }
    })
  },

  async updateOwner({ encounterId, oldOwner, newOwner }) {
    const updateEncounter = await this.updateReviewInfo({
      userId: newOwner,
      encounterId
    })

    if (!updateEncounter) return updateEncounter

    return EventService.create({
      type: 'encounterEvent',
      event: 'updateOwner',
      encounterId,
      data: {
        oldOwner,
        newOwner
      }
    })
  }
}

export default EncountersService
